'use es6';

import { BILLING_WRITE } from 'pricing-pages-lib/constants/Scopes';
import { createSelector } from 'reselect';
export const authSelector = state => state.auth; // Permissions to make changes/buy products that require purchases

export const isBillingAdminSelector = createSelector(authSelector, auth => {
  // This check is only for if we dual-deploy and have non-auth
  if (!auth || !auth.user || !auth.user.scopes) {
    return false;
  }

  const scopeList = auth.user.scopes;
  const hasHubBillingWrite = scopeList.some(scope => scope === BILLING_WRITE);
  return hasHubBillingWrite;
});